(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/reducers/personal-result-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/reducers/personal-result-reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _RTK = RTK,
  createReducer = _RTK.createReducer;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const _svs$components$marke = svs.components.marketplaceCompetition.services.actions.personalResultActions,
  fetchPersonalResultsAction = _svs$components$marke.fetchPersonalResultsAction,
  patchPersonalResultsAction = _svs$components$marke.patchPersonalResultsAction;
const personalResultState = {
  Competitions: {}
};
const getPersonalResultModel = (state, competitionId) => {
  if (!state.Competitions[competitionId]) {
    state.Competitions[competitionId] = {
      individual: undefined,
      teams: {}
    };
  }
  return state.Competitions[competitionId];
};
const getIndividualModel = (state, competitionId) => {
  const personalResults = getPersonalResultModel(state, competitionId);
  if (!personalResults.individual) {
    personalResults.individual = {
      data: {},
      lastFetch: null,
      status: FetchState.Idle
    };
  }
  return personalResults.individual;
};
const getTeamModel = (state, competitionId, teamId) => {
  const personalResults = getPersonalResultModel(state, competitionId);
  if (!personalResults.teams[teamId]) {
    personalResults.teams[teamId] = {
      data: {},
      lastFetch: null,
      status: FetchState.Idle
    };
  }
  return personalResults.teams[teamId];
};
const personalResultReducer = createReducer(personalResultState, builder => {
  builder.addCase(fetchPersonalResultsAction.pending, (state, action) => {
    const _action$meta$arg = action.meta.arg,
      competitionId = _action$meta$arg.competitionId,
      teamIds = _action$meta$arg.teamIds,
      shouldFetchIndividualResults = _action$meta$arg.shouldFetchIndividualResults;
    if (shouldFetchIndividualResults) {
      const individualResult = getIndividualModel(state, competitionId);
      individualResult.status = FetchState.Pending;
    }
    teamIds.forEach(teamId => {
      const teamResult = getTeamModel(state, competitionId, teamId);
      teamResult.status = FetchState.Pending;
    });
  }).addCase(fetchPersonalResultsAction.fulfilled, (state, action) => {
    const newDateString = new Date().toISOString();
    const _action$payload = _slicedToArray(action.payload, 2),
      individualResult = _action$payload[0],
      teamsResult = _action$payload[1];
    const _action$meta$arg2 = action.meta.arg,
      competitionId = _action$meta$arg2.competitionId,
      teamIds = _action$meta$arg2.teamIds,
      shouldFetchIndividualResults = _action$meta$arg2.shouldFetchIndividualResults;
    if (shouldFetchIndividualResults) {
      const individualResultModel = getIndividualModel(state, competitionId);
      individualResultModel.status = FetchState.Fulfilled;
      individualResultModel.lastFetch = newDateString;
      if (Object.keys(individualResult).length > 0) {
        individualResultModel.data = individualResult;
      }
    }
    teamIds.forEach(teamId => {
      if (Object.keys(teamsResult[teamId]).length > 0) {
        const teamResultModel = getTeamModel(state, competitionId, teamId);
        teamResultModel.status = FetchState.Fulfilled;
        teamResultModel.lastFetch = newDateString;
        teamResultModel.data = teamsResult[teamId];
      } else {
        delete state.Competitions[competitionId].teams[teamId];
      }
    });
  }).addCase(fetchPersonalResultsAction.rejected, (state, action) => {
    const _action$meta$arg3 = action.meta.arg,
      competitionId = _action$meta$arg3.competitionId,
      teamIds = _action$meta$arg3.teamIds,
      shouldFetchIndividualResults = _action$meta$arg3.shouldFetchIndividualResults;
    if (shouldFetchIndividualResults) {
      const individualResult = getIndividualModel(state, competitionId);
      individualResult.status = FetchState.Rejected;
    }
    teamIds.forEach(teamId => {
      const teamResult = getTeamModel(state, competitionId, teamId);
      teamResult.status = FetchState.Rejected;
    });
  }).addCase(patchPersonalResultsAction, (state, action) => {
    const _ref = action.payload || {},
      competitionId = _ref.competitionId,
      data = _ref.data;
    if (!competitionId || !data) {
      return;
    }

    const normalizePersonalResults = svs.components.marketplaceCompetition.services.helpers.normalizePersonalResults;
    const _normalizePersonalRes = normalizePersonalResults(data),
      _normalizePersonalRes2 = _slicedToArray(_normalizePersonalRes, 2),
      individualResult = _normalizePersonalRes2[0],
      teamsResult = _normalizePersonalRes2[1];
    const newDateString = new Date().toISOString();
    if (individualResult) {
      const individualModel = getIndividualModel(state, competitionId);
      individualModel.data = _objectSpread(_objectSpread({}, individualModel.data), individualResult);
      individualModel.lastFetch = newDateString;
      individualModel.status = FetchState.Fulfilled;
    }
    Object.keys(teamsResult).forEach(teamId => {
      const teamData = teamsResult[teamId];
      const teamModel = getTeamModel(state, competitionId, teamId);
      teamModel.data = _objectSpread(_objectSpread({}, teamModel.data), teamData);
      teamModel.lastFetch = newDateString;
      teamModel.status = FetchState.Fulfilled;
    });
  });
});
setGlobal('svs.components.marketplaceCompetition.services.reducers.personalResultReducer', personalResultReducer);

 })(window);